import React, { useState } from 'react';
import { colors } from '../styles';

const styles = {
  container: {
    marginTop: '1rem',
  },
  label: {
    fontSize: '0.8rem',
    color: colors.textSecondary,
    marginBottom: '0.5rem',
    display: 'block',
  },
  buttons: {
    display: 'flex',
    gap: '0.5rem',
  },
  button: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.375rem',
    padding: '0.625rem 0.75rem',
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.75rem',
    fontWeight: 500,
    color: colors.textSecondary,
  },
  buttonHover: {
    backgroundColor: colors.surfaceHover,
  },
  buttonCorrect: {
    borderColor: colors.success,
    color: colors.success,
    backgroundColor: colors.successBg,
  },
  buttonWrong: {
    borderColor: colors.error,
    color: colors.error,
    backgroundColor: colors.errorBg,
  },
  icon: {
    fontSize: '0.875rem',
  },
};

export default function FeedbackButtons({ lugarNombre, tipoPersona = false }) {
  const [hoveredCorrect, setHoveredCorrect] = useState(false);
  const [hoveredWrong, setHoveredWrong] = useState(false);
  const [feedbackGiven, setFeedbackGiven] = useState(null);

  const handleCorrect = () => {
    console.log(`Feedback: Información correcta para ${lugarNombre}`);
    setFeedbackGiven('correct');
    // En Fase 2 esto enviará datos al backend
  };

  const handleWrong = () => {
    console.log(`Feedback: Algo está mal en ${lugarNombre}`);
    setFeedbackGiven('wrong');
    // En Fase 2 esto abrirá un formulario de reporte
  };

  if (feedbackGiven) {
    return (
      <div style={styles.container}>
        <p style={{ ...styles.label, color: colors.success, textAlign: 'center' }}>
          Gracias por tu feedback
        </p>
      </div>
    );
  }

  const label = tipoPersona
    ? `¿Conoces a ${lugarNombre.split(' ')[0]}?`
    : '¿Conoces este lugar?';

  return (
    <div style={styles.container}>
      <span style={styles.label}>{label}</span>
      <div style={styles.buttons}>
        <button
          style={{
            ...styles.button,
            ...(hoveredCorrect ? styles.buttonHover : {}),
          }}
          onClick={handleCorrect}
          onMouseEnter={() => setHoveredCorrect(true)}
          onMouseLeave={() => setHoveredCorrect(false)}
        >
          <span style={styles.icon}>✓</span>
          <span>Info correcta</span>
        </button>
        <button
          style={{
            ...styles.button,
            ...(hoveredWrong ? styles.buttonHover : {}),
          }}
          onClick={handleWrong}
          onMouseEnter={() => setHoveredWrong(true)}
          onMouseLeave={() => setHoveredWrong(false)}
        >
          <span style={styles.icon}>✗</span>
          <span>Algo está mal</span>
        </button>
      </div>
    </div>
  );
}
